import { useCallback, useEffect, useState } from "react";
import { VersionChangedRefreshTimer } from "~/constants/versionUpdater";
import { getWindowEnv } from "~/helpers/envConfig";

export const useGetEnvVersionFromFile = () => {
  const [versionChanged, setVersionChanged] =
    useState<VersionChangedRefreshTimer>(0);

  const { XSIGHT_VERSION } = getWindowEnv();
  const currentVersion = XSIGHT_VERSION;

  const getUpToDateXSightVersion = useCallback(async () => {
    const response = await (
      await fetch("/env-config.js", { cache: "no-store" })
    ).text();

    const envStr = response.replace("window._env_ = ", "");
    const { XSIGHT_VERSION: xsightVersion } = getWindowEnv(envStr);

    setVersionChanged(
      (c) =>
        (xsightVersion !== currentVersion
          ? ++c
          : c) as VersionChangedRefreshTimer,
    );

    return xsightVersion;
  }, [currentVersion]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      getUpToDateXSightVersion();
    }, 60000); // each tick 1 minute

    return () => {
      clearInterval(intervalId);
    };
  }, [getUpToDateXSightVersion]);

  return { versionChanged, setVersionChanged };
};
